function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "url(#paint0_linear_7935_137774)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.99531 4.642H7.00731V3.004H8.99531V4.642ZM7.00731 5.762H8.99531V13H7.00731V5.762Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_7935_137774",
  x1: 0,
  y1: 8.08989,
  x2: 16,
  y2: 8.08989,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#16AABB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1A7ECB"
})));

var SvgIconInfoActive = function SvgIconInfoActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInfoActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_info_active.68c80d87.svg";
export { ForwardRef as ReactComponent };